// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AccountModel } from './accountModel.js';
import type { PatientModel } from './patientModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteAccountV2PatientsPatientAccountModel {
    'account': AccountModel | null;
    'patient': PatientModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteAccountV2PatientsPatientAccountModel>> = [
        {
            "name":     "account",
            "baseName": "account",
            "type":     "AccountModel"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "PatientModel"
        },
    ];

    static getAttributeTypeMap() {
        return SiteAccountV2PatientsPatientAccountModel.attributeTypeMap;
    }
}
